module.exports = __webpack_public_path__ + "img/VCG211288687183.b731fc9f.jpg";